import $ from "jquery";

$('.product-customisation__choice-item input').on('input', function () {
    var checked = $('#customisation-yes').prop("checked");
    var content = $('.product-customisation__content');
    var images  = $('.product-customisation__images');

    if (checked == true) {
        content.addClass('is-visible');
        images.addClass('is-visible');
    } else {
        content.removeClass('is-visible');
        images.removeClass('is-visible');

        $('#customisation-text-1').val('');
        $('#customisation-text-2').val('');
        $('#customisation-text-3').val('');
        $('#svg-custom-line-1 textPath').text('');
        $('#svg-custom-line-2 textPath').text('');
        $('#svg-custom-line-3 textPath').text('');
    }
});
$('.product-customisation__choice-item input:first').trigger('input');


// Lorsqu'on change la couleur, on change l'image de la customisation
$('input[name=product_merged_variations]').on('change', function() {
    var color = $(this).val().split('|')[0];
    
    $('.product-customisation__image').hide();
    $('.product-customisation__image.custom-' + color).fadeIn('slow');
});
$('input[name=product_merged_variations]:first').trigger('change');

// Mise à jour des textes personnalisés
$('#customisation-text-1').on('keyup', function() {
    $('#svg-custom-line-1 textPath').text($(this).val());
});
$('#customisation-text-2').on('keyup', function() {
    $('#svg-custom-line-2 textPath').text($(this).val());
});
$('#customisation-text-3').on('keyup', function() {
    $('#svg-custom-line-3 textPath').text($(this).val());
});

$('#customisation-text-1, #customisation-text-2, #customisation-text-3').trigger('keyup');

// Affichage des informations sur la personnalisation du produit
$('.product-customisation__infos-icon').on('click', function () {
    $('.product-customisation__infos-content').addClass('product-customisation__infos-content--active');
});
$('.product-customisation__close-cross').on('click', function () {
    $('.product-customisation__infos-content').removeClass('product-customisation__infos-content--active');
});